import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

@Component({
	selector: "app-feedback-box",
	templateUrl: "./feedback-box.directive.html",
	styleUrls: ["./feedback-box.directive.css"],
})
export class FeedbackBoxDirective implements OnInit {
	@Input() feedBackData: any;
	@Output() closeFeedBack: EventEmitter<any> = new EventEmitter<any>();
	constructor() {}

	ngOnInit() {}
	public buttonClickHandler(feedBackData) {
		if (feedBackData.type == "correct") {
			this.closeFeedBack.emit("next");
		} else {
			this.closeFeedBack.emit("tryagain");
		}
	}
}
